var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "客户详情",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onHandleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "contents CustomerDetailsDialog" },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 3, border: "" } },
                [
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户姓名",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.fullname))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户电话",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.mobile))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "店铺名称",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.shopname))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "从事行业",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.industry_txt))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "下单总件数",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.order_qty) + "件")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "下单总重量",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.order_gross_weight) + "吨")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "注册时间",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.create_time))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "注册天数",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.days) + "天")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "日均下单件数",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.average_order_day_qty) + "件")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "首次下单时间",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.first_order_time))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "最近下单时间",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.last_order_time))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "平均下单件数",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.average_order_qty) + "件")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "缺货件数",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.stockout_num) + "件")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "售后件数",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.after_num) + "件")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "退款金额",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.refund_amt) + "元")]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "总退货件数",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.info.stockout_num + _vm.info.after_num) +
                          "件"
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户下单状态",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.customer_status_txt))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户近 10 日购买二级品top1",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.info.recent_10days_product_category2_top1)
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户购买品类偏好",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.customer_buy_category_preference))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户购买等级偏好",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.customer_buy_grade_preference))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户近 10 日购买二级品数",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.info.recent_10days_product_category2_cnt)
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户购买能力",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.purchase_hierarchy))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户活跃度",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.customer_activity_txt))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户近10日购买水果二级品列表",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.recent_10days_fruit_category2s))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户等级",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.star_customer_grade_detail))]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户标签",
                      },
                    },
                    _vm._l(_vm.info.labels, function (item, index) {
                      return _c(
                        "el-tag",
                        { key: index, attrs: { size: "small" } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户近10日购买蔬菜二级品类列表",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.info.recent_10days_vegetable_category2s)
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        "label-class-name": "my-label",
                        "content-class-name": "my-content",
                        label: "客户状态",
                      },
                    },
                    [_vm._v(_vm._s(_vm.info.black_status_txt))]
                  ),
                  _vm.info.black_status == 2 && _vm.info.delete_info
                    ? _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            "label-class-name": "my-label",
                            "content-class-name": "my-content",
                            label: "注销时间",
                          },
                        },
                        [_vm._v(_vm._s(_vm.info.delete_info.delete_time))]
                      )
                    : _vm._e(),
                  _vm.info.black_status == 2 && _vm.info.delete_info
                    ? _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            "label-class-name": "my-label",
                            "content-class-name": "my-content",
                            label: "注销操作人",
                          },
                        },
                        [_vm._v(_vm._s(_vm.info.delete_info.op_name))]
                      )
                    : _vm._e(),
                  _vm.info.black_status == 2 && _vm.info.delete_info
                    ? _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            "label-class-name": "my-label",
                            "content-class-name": "my-content",
                            label: "注销原因",
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.info.delete_info.reason) + " "),
                          _vm.info.delete_info.pic
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.centerDialogVisible = true
                                    },
                                  },
                                },
                                [_vm._v("查看注销证明")]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.onHandleClose } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "提示",
                visible: _vm.centerDialogVisible,
                width: "60%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { height: "500px", "overflow-y": "auto" } },
                _vm._l(_vm.info.delete_info.pic.split(","), function (url) {
                  return _c("el-image", {
                    key: url,
                    attrs: { src: url, lazy: "" },
                  })
                }),
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }